import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { Heart } from 'lucide-react';
export const CommunitySection = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: sectionRef,
    offset: ['start end', 'end start']
  });
  const translateY = useTransform(scrollYProgress, [0, 1], [0, -50]);
  const opacity = useTransform(scrollYProgress, [0, 0.2, 0.8, 1], [0, 1, 1, 0]);
  return <motion.section id="community" ref={sectionRef} className="py-20 md:py-28 bg-black relative overflow-hidden" style={{
    opacity
  }} data-id="element-138">
      <div className="absolute inset-0 z-0 bg-gradient-to-b from-amber-950/20 to-black" data-id="element-139"></div>
      <motion.div className="container mx-auto px-4 relative z-10" style={{
      y: translateY
    }} data-id="element-140">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-24" data-id="element-141">
          <p className="text-amber-400/60 tracking-[0.3em] text-xs uppercase mb-6" data-id="element-142">
            Cultural Preservation
          </p>
          <h2 className="font-serif text-5xl md:text-7xl text-white mb-8" data-id="element-143">
            COMMUNITY
            <br data-id="element-144" />
            <span className="text-amber-400" data-id="element-145">& CAUSE</span>
          </h2>
          <div className="w-24 h-px bg-amber-400/30 mx-auto mb-8" data-id="element-146"></div>
          <p className="text-xl text-white/70 max-w-3xl mx-auto font-light" data-id="element-147">
            This isn't just entertainment — it's preservation, pride, and seva.
          </p>
        </motion.div>
        {/* ROM Heritage Section */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="mb-20 max-w-4xl mx-auto" data-id="element-148">
          <div className="border-2 border-amber-400/40 p-8 md:p-12 bg-gradient-to-br from-amber-950/20 to-black/60" data-id="element-149">
            <div className="text-center mb-8" data-id="element-150">
              <h3 className="font-serif text-3xl md:text-4xl text-amber-400 mb-4" data-id="element-151">
                Building on a Legacy
              </h3>
              <div className="w-16 h-px bg-amber-400/30 mx-auto" data-id="element-152"></div>
            </div>
            <div className="max-w-3xl mx-auto" data-id="element-153">
              <p className="text-white/80 text-lg leading-relaxed mb-6 font-light text-center" data-id="element-154">
                This immersive experience honors the groundbreaking "Art of the
                Sikh Kingdoms" exhibition at the Royal Ontario Museum in August
                2000—the second most popular exhibition in ROM history.
              </p>
              <p className="text-white/70 leading-relaxed font-light text-center" data-id="element-155">
                Where that exhibition brought artifacts behind glass, we bring
                the entire kingdom to life around you—transforming scholarship
                into sensation, and history into an unforgettable evening.
              </p>
            </div>
          </div>
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-20" data-id="element-156">
          <p className="text-amber-400 font-light text-sm tracking-[0.3em] uppercase mb-6" data-id="element-157">
            Proudly Presented By
          </p>
          <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} whileInView={{
          scale: 1,
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-white rounded-lg p-8 inline-block" data-id="element-158">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/48U2qmRQoErrPvLaJoyvZa/akalsteellogo1.png" alt="Akal Steel Logo" className="w-40 h-auto object-contain" data-id="element-159" />
          </motion.div>
          <p className="text-white font-light text-lg mt-6 tracking-wider" data-id="element-160">
            Akal Steel (2005) Inc.
          </p>
        </motion.div>
        <div className="max-w-4xl mx-auto" data-id="element-161">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-162">
            <div className="relative overflow-hidden border border-amber-400/30 rounded-lg" data-id="element-163">
              <div className="aspect-[21/9] relative" data-id="element-164">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/onjzBJGQ8jS7o5qx5xJkRk/Global-sikh-art-and-Culture.jpg" alt="Royal Ontario Museum - Global Sikh Art & Culture" className="w-full h-full object-cover" data-id="element-165" />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent" data-id="element-166"></div>
              </div>
              <div className="absolute bottom-0 left-0 w-full p-12" data-id="element-167">
                <div className="flex items-center mb-6" data-id="element-168">
                  <Heart className="w-8 h-8 text-amber-400 mr-4" data-id="element-169" />
                  <h3 className="font-serif text-3xl text-amber-400" data-id="element-170">
                    Benefactor
                  </h3>
                </div>
                <p className="text-white/90 text-lg max-w-3xl font-light leading-relaxed" data-id="element-171">
                  A portion of all proceeds goes directly to the Sikh Art and
                  Culture Gallery at the Royal Ontario Museum, preserving Sikh
                  heritage for future generations.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="text-center max-w-3xl mx-auto mt-24" data-id="element-172">
          <p className="text-2xl text-amber-400 font-light italic" data-id="element-173">
            "Every ticket funds cultural storytelling + community uplift."
          </p>
        </motion.div>
      </motion.div>
    </motion.section>;
};